import BaseDialog from "@/components/BaseDialog";






// 查看&编辑 权限
export function tagFieldsConfigModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./tagFieldsConfig'),
        options: {
            width: '600px',
            title: '字段权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 普通 字段权限弹窗
export function baseRoleFieldModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./baseRoleFieldModal'),
        options: {
            width: '800px',
            title: props.actionType=='fields'?'字段权限':props.actionType=='notifier'?'通知人':'维度权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 三级/带tab的 字段权限弹窗
export function tabRoleFieldModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./tabRoleFieldModal'),
        options: {
            width: '1000px',
            title: props.actionType=='fields'?'字段权限':'维度权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
            customClass:'dialog-body-padding-top-10',
        },
        props,
        cbs,
    })
}

// 统计周期
export function statisticalPeriodModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./statisticalPeriodModal'),
        options: {
            width: '800px',
            title: '统计周期权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}

// 可选角色
export function configOptionRoleModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./configOptionRoleModal'),
        options: {
            width: '600px',
            title: '配置可选角色',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 可选角色
export function configOptionTableModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./configOptionTableModal'),
        options: {
            width: '600px',
            title: '配置表',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
// 抓取时段
export function retryDataModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./retryDataModal.vue'),
        options: {
            width: '450px',
            title: '抓取时段权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}


// 工单管理素材库页面-数据权限(需求方/制作方)
export function dataPermissionModal({ props, cbs }) {
    return new BaseDialog({
        component: ()=>import('./dataPermissionModal.vue'),
        options: {
            width: '600px',
            title: '数据权限',
            closeOnPressEscape:false,
            closeOnClickModal:false,
        },
        props,
        cbs,
    })
}
